export const categoriesAlias = {
  default_penalties: 'Desc. fijos',
  discounts: 'Otros desc.',
  weekly_bonus: 'Bono Fijo',
  loan_payments: 'Descuentos.',
  loans: 'Prest.',
  cancelations_and_downgrades: 'Canc. y down.',
  new_sales_commissions: 'Coms. nuevas',
  upgrades_commissions: 'Coms. upgr.',
  payments_commissions: 'Coms. pend.',
  payer: 'Pagadora',
  cancelling_fund: 'Desc. x f. canc.',
  cancelling_fund_wp: "Desc. x f. canc. WP",
  qs_commissions: 'Qs',
  trs:'Trs',
  fly_and_by:'F&B',
  exchange:'Intercambio',
  chargebacks: 'Desc. x reg.',
  adjustment_with_discount:'Ajuste con descuento',
  infonavit:'Infonavit',
  administrative_commission:'Comisiones'
}
